import TextField from './textInput';
import DatePicker from './datepicker';
import { INDENTIFIER } from '../../constants';
export const FormFields = {
  [INDENTIFIER.INPUTTEXT]: TextField,
  [INDENTIFIER.DATEPICKER]: DatePicker
}